import React from "react";
import "./ChantInput.css";
import { Input } from "antd";
import { Controller } from "react-hook-form";

const ChantInput = ({
  label,
  helpText,
  control,
  name,
  required,
  rules,
  disabled,
  value,
  defaultValue,
  onChange: customOnChange,
  ...props
}) => {
  const handleChange = (e) => {
    if (customOnChange) {
      customOnChange(e);
    }
  };

  // If control and name are provided, use Controller pattern
  if (control && name) {
    return (
      <div className="chant-input-container">
        {label && (
          <label className="chant-input-label">
            {label} {required ? <span style={{ color: "red" }}>*</span> : null}
          </label>
        )}
        <div className="chant-input-wrapper">
          <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Input
                  {...field}
                  {...props}
                  required={required}
                  status={error ? "error" : ""}
                  disabled={disabled}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    // Call React Hook Form's onChange first
                    field.onChange(e);
                    // Then call custom onChange if provided
                    if (customOnChange) {
                      customOnChange(e);
                    }
                  }}
                />
                {error && (
                  <div className="chant-input-error">{error.message}</div>
                )}
              </div>
            )}
          />
        </div>
        {helpText && <div className="chant-input-help">{helpText}</div>}
      </div>
    );
  }

  // Otherwise, use the regular pattern for backward compatibility
  return (
    <div className="chant-input-container">
      {label && (
        <label className="chant-input-label">
          {label} {required ? <span style={{ color: "red" }}>*</span> : null}
        </label>
      )}
      <div className="chant-input-wrapper">
        <Input
          {...props}
          name={name}
          required={required}
          disabled={disabled}
          value={value}
          defaultValue={defaultValue}
          onChange={handleChange}
          onWheel={(e) => e.target.blur()}
        />
      </div>
      {helpText && <div className="chant-input-help">{helpText}</div>}
    </div>
  );
};

export default ChantInput;
